export const SPECIAL_REQUEST_PRODUCT_COST = 6

export const AGE_RESTRICTED_ITEMS_BANNER_TITLE = 'ID required at delivery'
export const AGE_RESTRICTED_ITEMS_BANNER_SUBTITLE =
  'This order has age-restricted items. The recipient must show the shopper a valid ID at delivery to verify they’re of legal age.'
